<template>
  <div class="mt-4 px-5">
    <v-alert dense text shaped type="info">
      <b>Genehmigungen</b>
      <div>
        Hier können Sie die Arbeitsstunden-Einträge der Mitglieder genehmigen oder ablehnen.
      </div>
    </v-alert>

    <v-data-table
      :headers="headers"
      :items="$store.state.ClubApp.ArbeitsstundenFreigaben"
      :loading="loading"
      sort-by="beginn"
      class="elevation-1"
    >
      <template v-slot:item.zeitraum="{ item }">
        {{ formatDateTime(item.beginn) }} - {{ formatDateTime(item.ende) }}
      </template>

      <template v-slot:item.details="{ item }">
        <div v-if="item.arbeitseinsatz_titel"><b>Einsatz:</b> {{ item.arbeitseinsatz_titel }}</div>
        <div v-if="item.funktion_name"><b>Funktion:</b> {{ item.funktion_name }}</div>
      </template>

      <template v-slot:item.actions="{ item }">
        <v-btn small color="success" class="mr-2" @click="approveEntry(item)">
          <v-icon left small>mdi-check</v-icon>
          Genehmigen
        </v-btn>
        <v-btn small color="error" class="mr-2" @click="openRejectDialog(item)">
          <v-icon left small>mdi-close</v-icon>
          Ablehnen
        </v-btn>
        <v-btn small color="info" @click="openEditDialog(item)">
          <v-icon left small>mdi-pencil</v-icon>
          Korrektur
        </v-btn>
      </template>
    </v-data-table>

    <!-- Ablehnungsgrund Dialog -->
    <v-dialog v-model="rejectDialog" max-width="500px">
      <v-card>
        <v-card-title>Eintrag ablehnen</v-card-title>
        <v-card-text>
          <v-textarea
            v-model="rejectReason"
            label="Grund der Ablehnung"
            outlined
            rows="3"
          ></v-textarea>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="rejectDialog = false">Abbrechen</v-btn>
          <v-btn color="error" :disabled="!rejectReason" @click="rejectEntry">Ablehnen</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Korrektur Dialog -->
    <v-dialog v-model="editDialog" max-width="500px">
      <v-card v-if="editingItem">
        <v-card-title>Eintrag korrigieren</v-card-title>
        <v-card-text>
          <v-text-field
            v-model="editingItem.beginn"
            label="Beginn"
            type="datetime-local"
            outlined
          ></v-text-field>
          <v-text-field
            v-model="editingItem.ende"
            label="Ende"
            type="datetime-local"
            outlined
          ></v-text-field>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="editDialog = false">Abbrechen</v-btn>
          <v-btn color="primary" @click="saveCorrection">Speichern</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>

export default {
  name: "WorkinghoursApprovals",
  data() {
    return {
      loading: false,
      headers: [
        { text: "Name", value: "user_name" },
        { text: "Vorname", value: "user_vorname" },
        { text: "Mitgliedsnr.", value: "mitgliedsnummer" },
        { text: "Zeitraum", value: "zeitraum", sortable: false },
        { text: "Details", value: "details", sortable: false },
        { text: "Aktionen", value: "actions", sortable: false },
      ],
      rejectDialog: false,
      rejectReason: "",
      rejectingItem: null,
      editDialog: false,
      editingItem: null,
    };
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    async fetchData() {
      this.loading = true;
      try {
        await this.$store.dispatch("ClubApp/getArbeitsstundenFreigaben");
      } catch (error) {
        console.error("Fehler beim Laden der Freigaben:", error);
      } finally {
        this.loading = false;
      }
    },
    formatDateTime(dateTimeStr) {
      if (!dateTimeStr) return "";
      const date = new Date(dateTimeStr.replace(" ", "T"));
      return date.toLocaleString([], {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
      });
    },
    async approveEntry(item) {
      try {
        await this.$store.dispatch("ClubApp/setArbeitsstundenFreigabe", {
          shootingbook_id: item.id,
          freigabebool: true,
        });
        this.fetchData();
      } catch (error) {
        console.error("Fehler beim Genehmigen:", error);
      }
    },
    openRejectDialog(item) {
      this.rejectingItem = item;
      this.rejectReason = "";
      this.rejectDialog = true;
    },
    async rejectEntry() {
      try {
        await this.$store.dispatch("ClubApp/setArbeitsstundenFreigabe", {
          shootingbook_id: this.rejectingItem.id,
          freigabebool: false,
          abgelehnt_grund: this.rejectReason,
        });
        this.rejectDialog = false;
        this.fetchData();
      } catch (error) {
        console.error("Fehler beim Ablehnen:", error);
      }
    },
    openEditDialog(item) {
      this.editingItem = {
        id: item.id,
        beginn: item.beginn.replace(" ", "T"),
        ende: item.ende.replace(" ", "T"),
      };
      this.editDialog = true;
    },
    async saveCorrection() {
      try {
        await this.$store.dispatch("ClubApp/setArbeitsstundenKorrektur", {
          shootingbook_id: this.editingItem.id,
          beginn: this.editingItem.beginn.replace("T", " "),
          ende: this.editingItem.ende.replace("T", " "),
        });
        this.editDialog = false;
        this.fetchData();
      } catch (error) {
        console.error("Fehler bei der Korrektur:", error);
      }
    },
  },
};
</script>
